// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import App from './App';
import store from './store';
import * as constants from './constants';
require('es6-promise').polyfill();

Vue.config.productionTip = true;

Vue.use(VeeValidate, { inject: false });

/* eslint-disable no-new */
new Vue({
	el: '#pow-app',
	store,
	template: '<App/>',
	components: { App },
	created () {
		document.documentElement.setAttribute('data-useragent', navigator.userAgent);
		window.fbAsyncInit = () => {
			// eslint-disable-next-line
			FB.init({
				appId: constants.FB_APP_ID,
				autoLogAppEvents: true,
				xfbml: true,
				version: constants.FB_SDK_VERSION,
			});
		};

		(function (d, s, id) {
			let js = d.getElementsByTagName(s)[0];
			const fjs = js;
			if (d.getElementById(id)) { return; }
			js = d.createElement(s);
			js.id = id;
			js.src = 'https://connect.facebook.net/en_US/sdk.js';
			fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
	},
});



// WEBPACK FOOTER //
// ./src/main.js